"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverPosition = void 0;
var PopoverPosition;
exports.PopoverPosition = PopoverPosition;

(function (PopoverPosition) {
  PopoverPosition["TopLeading"] = "top-leading";
  PopoverPosition["TopCenter"] = "top-center";
  PopoverPosition["TopTrailing"] = "top-trailing";
  PopoverPosition["BottomLeading"] = "bottom-leading";
  PopoverPosition["BottomCenter"] = "bottom-center";
  PopoverPosition["BottomTrailing"] = "bottom-trailing";
})(PopoverPosition || (exports.PopoverPosition = PopoverPosition = {}));